

























































import { Component, Prop, Vue } from 'vue-property-decorator';

import AddParkModal from './components/adminTabParkAdd.vue';
import EditParkModal from './components/adminTabParkEdit.vue';
import DeleteParkModal from './components/adminTabParkDelete.vue';

import { IPark } from '@/models/IPark.model.ts';
import { ParksAPI } from '@/apis/parks.api';

@Component({
    components: {
      'add-park-modal': AddParkModal,
      'edit-park-modal': EditParkModal,
      'delete-park-modal': DeleteParkModal,
    },
})
export default class TabParksView extends Vue {

  @Prop() public parks!: IPark[];

  private first = false;

  public parkAdd($park: IPark){
    this.$emit('add', $park )
  }

  public async parkEdit($park: IPark){
    this.$emit('edit', $park)
  }

  public async parkDelete($park: IPark){
    const parkApi = new ParksAPI();
    await parkApi.delete($park);
    this.$emit('remove', $park )
  }

  public async downloadJSON() {
    const parkApi = new ParksAPI();
    const parks = await parkApi.getAll();

    var jsonData = JSON.parse(JSON.stringify(parks)+'');
    var content = JSON.stringify(jsonData);
    var fileName =  'parks.json';
    var contentType =  'text/plain'
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

}
